import { useState } from "react";
import { useUserDirectory } from "../../backend/queries/users";
import { useDebouncedValue } from "../../hooks/useDebouncedValue";
import { UserLearningAssignments } from "../../components/learning/UserLearningAssignments";
import {
  EmptyState,
  ErrorState,
  LoadingState,
  PageSection,
} from "../../components/patterns";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";

export function LearningAssignmentPanel() {
  const [search, setSearch] = useState("");
  const [userId, setUserId] = useState("");
  const query = useDebouncedValue(search);
  const users = useUserDirectory({
    status: "active",
    search: query,
    limit: 50,
  });
  return (
    <div className="grid gap-5">
      <PageSection title="Assign to a person">
        <div className="grid max-w-md gap-3">
          <Label htmlFor="learning-user-search">Find a user</Label>
          <Input
            id="learning-user-search"
            value={search}
            placeholder="Search by name"
            onChange={(event) => {
              setSearch(event.target.value);
              setUserId("");
            }}
          />
          {users.isPending ? (
            <LoadingState label="Loading users" />
          ) : users.error ? (
            <ErrorState onRetry={() => users.refetch()} />
          ) : (
            <Select value={userId} onValueChange={setUserId}>
              <SelectTrigger aria-label="Assign learning to">
                <SelectValue placeholder="Select a user" />
              </SelectTrigger>
              <SelectContent>
                {users.data?.items.filter((user) => (user.role === "Owner" || user.role === "Admin") || user.role === "Agent").map((user) => (
                  <SelectItem key={user.id} value={user.id}>
                    {user.firstname} {user.lastname} · {user.role}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
        </div>
      </PageSection>
      {userId ? (
        <UserLearningAssignments key={userId} userId={userId} />
      ) : (
        <EmptyState
          size="inline"
          title="Select a user"
          description="Their courses will appear here."
        />
      )}
    </div>
  );
}
